import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import "./FormStyles.css";
import "./Tenant.css";
import useAxios from "./useAxios";

const Tenant = () => {
  const { id } = useParams();

  const [tenant, setTenant] = useState(null);
  const [axios] = useAxios(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get("tenant/" + id, setTenant);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTenant((prevTenant) => ({ ...prevTenant, [name]: value }));
  };

  const onSave = () => {
    axios.post("tenant/" + id, tenant, onCancel);
  };

  const onCancel = () => {
    navigate("/tenants");
  };

  if (tenant === null) {
    return <h1>Loading</h1>;
  }

  return (
    <div className="edit-tenant-form">
      <h2>Edit Tenant</h2>
      <form className="tenant-form-fields">
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            name="name"
            id="name"
            value={tenant.name}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="domain">Domain:</label>
          <input
            type="text"
            name="domain"
            id="domain"
            value={tenant.domain}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="icon">Icon:</label>
          <input
            type="text"
            name="icon"
            id="icon"
            value={tenant.icon}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="remoteAccessHelpUrl">Remote Access Help URL:</label>
          <input
            type="text"
            name="remoteAccessHelpUrl"
            id="remoteAccessHelpUrl"
            value={tenant.remoteAccessHelpUrl || ""}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-buttons">
          <button type="button" onClick={onSave} className="submit-button">
            Save
          </button>
          <button type="button" onClick={onCancel} className="cancel-button">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Tenant;
